import React, { FC } from "react";
import { Box, SimpleGrid } from "@chakra-ui/react";
import { TGrsPendingLeadDetail } from "types/grs-pending-lead.type";
import {
  buildGrsAgentNotesLines,
  buildGrsPropertyDetailLines,
} from "utils/grs-pending-leads.utils";

interface IGrsPendingLeadDetailsSectionProps {
  heading: string;
  lines: string[];
}

const GrsPendingLeadDetailsSection: FC<IGrsPendingLeadDetailsSectionProps> = ({
  heading,
  lines,
}) => {
  return (
    <Box mb={4}>
      <Box fontWeight={"bold"} color={"leadpro.700"} mb={1}>
        {heading}
      </Box>
      {!lines.length && <Box color={"leadpro.400"}>Not provided</Box>}
      {lines.map((line, index) => (
        <Box key={index} color={"leadpro.700"} whiteSpace={"pre-wrap"} mb={1}>
          {line}
        </Box>
      ))}
    </Box>
  );
};

interface IGrsPendingLeadDetailsPanelProps {
  detail: TGrsPendingLeadDetail;
}

export const GrsPendingLeadDetailsPanel: FC<IGrsPendingLeadDetailsPanelProps> = ({
  detail,
}) => {
  return (
    <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
      <Box>
        <GrsPendingLeadDetailsSection
          heading={"Lead Source"}
          lines={["Nurtur (GRS)"]}
        />
        <GrsPendingLeadDetailsSection
          heading={"Property Details"}
          lines={buildGrsPropertyDetailLines(detail)}
        />
      </Box>
      <GrsPendingLeadDetailsSection
        heading={"Agent Notes"}
        lines={buildGrsAgentNotesLines(detail)}
      />
    </SimpleGrid>
  );
};
